import React from 'react';
import { TFunction } from 'i18next';
import dayjs from 'dayjs';
import { ISubscriptionItem } from 'interfaces';


interface GetColumnsProps {
  t: TFunction;
  onOpenDetails: (record: ISubscriptionItem) => void;
}

export const getSubscriptionsColumns = ({
  t,
  onOpenDetails,
}: GetColumnsProps) => {
  return [
    {
      title: t('Billing.subscriptions.columns.tariff'),
      dataIndex: 'tariff_name',
      key: 'tariff_name',
      width: '28%',
    },
    {
      title: t('Billing.subscriptions.columns.nextBilling'),
      dataIndex: 'next_billing_at',
      key: 'next_billing_at',
      width: '26%',
      sorter: (a: ISubscriptionItem, b: ISubscriptionItem) => {
        const aVal = a.next_billing_at ? dayjs(a.next_billing_at).valueOf() : 0;
        const bVal = b.next_billing_at ? dayjs(b.next_billing_at).valueOf() : 0;
        return aVal - bVal;
      },
      render: (val: string | null) =>
        val ? dayjs(val).format('YYYY.MM.DD') : '——',
    },
    {
      title: t('Billing.subscriptions.columns.paymentMethod'),
      dataIndex: 'payment_card',
      key: 'payment_card',
      width: '28%',
    },
    {
      title: t('Billing.subscriptions.columns.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '18%',
      render: (_: any, record: ISubscriptionItem) => (
        <a onClick={() => onOpenDetails(record)}>
          {t('Billing.subscriptions.actions.details')}
        </a>
      ),
    },
  ];
};
